/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format'
import * as fromFormat1 from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/SimilarPatients/Content/Content/SimilarPerson/Person/Info/Details/Name"
  
}) {
let similarPersonValueData = fromData.useDataFormat({ viewPath,
context: 'similar_person',
format: fromFormat.statusPersonName,
})
let constantData = ','
let aggregateData = fromAggregate.joinNoSpace(similarPersonValueData, constantData)
let similarPersonGender0ValueData = fromData.useDataValue({ viewPath,
context: 'similar_person',
path: 'gender[0]',
})
let constantData1 = ','
let aggregateData1 = fromAggregate.joinNoSpace(similarPersonGender0ValueData, constantData1)
let similarPersonBirthDateValueData = fromData.useDataFormat({ viewPath,
context: 'similar_person',
path: 'birth_date',
format: fromFormat1.dateShortIn,
})
  return (<React.Fragment
>
<div
  data-testid="Name.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="similar_person"
 format="/Data/format statusPersonName"
 data="','"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="similar_person.gender[0]"
 data="','"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData1}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="similar_person.birth_date"
 format="/Data/format.js dateShortIn"
 text={similarPersonBirthDateValueData}
/>
</div>
{children}
</React.Fragment>)
}